/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Resource Selectors 

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../constants/resourceTypeConstants";
import {createSelector} from 'reselect'

export const resourcesSelector = state => state.resources.resources;
export const uuidSelector = (state, incomingUUID) => incomingUUID;

export const allUserAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT] || {}
);
export const allUserAccountBalancesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_BALANCE] || {}
);
export const allUserAccountBalanceSourcesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE] || {}
);
export const allUserHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_HISTORY_ENTRY] || {}
);
export const allBalanceChangeLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BALANCE_CHANGE_LOG] || {}
);
export const allInternationalBankAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT] || {}
);
export const allUSDomesticBankAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT] || {}
);
export const allUserBankAccountDeltasSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA] || {}
);
export const allUserAccountSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS] || {}
);
export const allAdminGhostUserAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST] || {}
);
export const allUserAccountFinalizationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION] || {}
);
export const allThirdPartyUserAccountMappingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING] || {}
);
export const allPreviousEmailAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS] || {}
);
export const allPendingEmailChangesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PENDING_EMAIL_CHANGE] || {}
);
export const allArchivedPendingEmailChangesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE] || {}
);
export const allPasswordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PASSWORD] || {}
);
export const allExpiredPasswordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EXPIRED_PASSWORD] || {}
);
export const allPasswordResetsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PASSWORD_RESET] || {}
);
export const allDepositsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT] || {}
);
export const allDepositInvitesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_INVITE] || {}
);
export const allDepositAdjustmentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT] || {}
);
export const allDepositInterestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_INTEREST] || {}
);
export const allDepositHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY] || {}
);
export const allDepositCloseRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST] || {}
);
export const allDepositUserStatsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_USER_STATS] || {}
);
export const allDepositBankMappingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING] || {}
);
export const allDepositBulkImportsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT] || {}
);
export const allDepositInterestLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG] || {}
);
export const allArchivedDepositCloseRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST] || {}
);
export const allDepositWithheldFundsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS] || {}
);
export const allPmcReportTimetablesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PMC_REPORT_TIMETABLE] || {}
);
export const allDepositGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_GROUP] || {}
);
export const allDepositPostCloseAdjustmentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT] || {}
);
export const allDepositUserGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_USER_GROUP] || {}
);
export const allPropertyGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY_GROUP] || {}
);
export const allPropertyUserGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY_USER_GROUP] || {}
);
export const allDisputesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DISPUTE] || {}
);
export const allDisputeSplitsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DISPUTE_SPLIT] || {}
);
export const allDisputeInterventionRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST] || {}
);
export const allPropertiesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY] || {}
);
export const allPropertyAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY_ADDRESS] || {}
);
export const allCompliancesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_COMPLIANCE] || {}
);
export const allComplianceRuleSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_COMPLIANCE_RULE] || {}
);
export const allComplianceHistoriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_COMPLIANCE_HISTORY] || {}
);
export const allEmailTemplatesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_TEMPLATE] || {}
);
export const allEmailVerificationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_VERIFICATION] || {}
);
export const allEmailVerificationRecordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD] || {}
);
export const allEmailEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_EVENT] || {}
);
export const allSentEmailsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SENT_EMAIL] || {}
);
export const allMailboxesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_MAILBOX] || {}
);
export const allMailboxMetaDataSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_MAILBOX_META_DATA] || {}
);
export const allMailboxMessagesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_MAILBOX_MESSAGE] || {}
);
export const allPermissionEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMISSION_ENTRY] || {}
);
export const allPermissionLogEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMISSION_LOG_ENTRY] || {}
);
export const allPermissionsOrganizationSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS] || {}
);
export const allResourcePermissionsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_RESOURCE_PERMISSIONS] || {}
);
export const allOrganizationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ORGANIZATION] || {}
);
export const allOrganizationResourcePermissionRulesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE] || {}
);
export const allInvoicesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_INVOICE] || {}
);
export const allInvoiceItemsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_INVOICE_ITEM] || {}
);
export const allPaymentRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PAYMENT_REQUEST] || {}
);
export const allStripePaymentLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_STRIPE_PAYMENT_LOG] || {}
);
export const allUserWithdrawsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_WITHDRAW] || {}
);
export const allPriorityAchPaymentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT] || {}
);
export const allPriorityAchRecurringPaymentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT] || {}
);
export const allLoanApplicationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_APPLICATION] || {}
);
export const allLoanSystemInfosSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_SYSTEM_INFO] || {}
);
export const allLoansSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN] || {}
);
export const allHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_HISTORY] || {}
);
export const allLoanPaymentLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_PAYMENT_LOG] || {}
);
export const allLogEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG] || {}
);
export const allInfoSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO] || {}
);
export const allSezzleOrdersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SEZZLE_ORDER] || {}
);
export const allSezzleWebhookEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT] || {}
);
export const allBankAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT] || {}
);
export const allBankAccountHistoricalInterestRatesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE] || {}
);
export const allBankAccountInterestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST] || {}
);
export const allBankAccountBalanceRecordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD] || {}
);
export const allBankTransfersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_TRANSFER] || {}
);
export const allBulkFundsTransfersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BULK_FUNDS_TRANSFER] || {}
);
export const allFundsLocksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_FUNDS_LOCK] || {}
);
export const allFundsLockReleaseLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG] || {}
);
export const allReleasedFundsLocksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_RELEASED_FUNDS_LOCK] || {}
);
export const allBalanceSourceTransfersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER] || {}
);
export const allCreditUserAccountLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG] || {}
);
export const allEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EVENT] || {}
);
export const allEventHooksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EVENT_HOOK] || {}
);
export const allNotificationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_NOTIFICATION] || {}
);
export const allActionItemsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ACTION_ITEM] || {}
);
export const allUpdateLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_UPDATE_LOG_ENTRY] || {}
);
export const allStorageFilesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_STORAGE_FILE] || {}
);
export const allAttachedStorageFilesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ATTACHED_STORAGE_FILES] || {}
);
export const allSystemHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY] || {}
);
export const allSnapshotsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SNAPSHOT] || {}
);
export const allIpAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_IP_ADDRESS] || {}
);
export const allKnownIpAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_KNOWN_IP_ADDRESS] || {}
);
export const allUserAgentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_AGENT] || {}
);
export const allKnownUserAgentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_KNOWN_USER_AGENT] || {}
);
export const allSystemStatsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SYSTEM_STATS] || {}
);
export const allResourceNoteSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_RESOURCE_NOTE] || {}
);
export const allDeposifyTagsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIFY_TAG] || {}
);
export const allLinksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMANENT_LINK] || {}
);
export const allOnlineUsersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ONLINE_USER] || {}
);
export const allFrontendGeneralSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS] || {}
);
export const allYardiScreeningWorksProXmlSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML] || {}
);
export const allYardiVoyagerXmlSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_XML] || {}
);
export const allYardiVoyagerTransactionsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION] || {}
);
export const allYardiVoyagerResidentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT] || {}
);
export const allYardiVoyagerResidentCustomColumnsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN] || {}
);
export const allYardiVoyagerPropertyUnitsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT] || {}
);
export const allYardiVoyagerPropertiesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY] || {}
);
export const allYardiVoyagerPmcServiceInterfaceVersionsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION] || {}
);
export const allYardiVoyagerPmcsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC] || {}
);
export const allYardiVoyagerPmcCredentialsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS] || {}
);
export const allYardiVoyagerPetsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PET] || {}
);
export const allYardiVoyagerIlsGuestCardEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT] || {}
);
export const allYardiVoyagerChargesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE] || {}
);
export const allYardiVoyagerChargeCodesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE] || {}
);
export const allYardiVoyagerDepositCreateIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT] || {}
);
export const allYardiVoyagerDepositCloseIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT] || {}
);
export const allYardiVoyagerDepositWithholdIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT] || {}
);
export const allYardiVoyagerEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_EVENT] || {}
);
export const allYardiVoyagerFlexDepositIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT] || {}
);
export const allYardiVoyagerPhonesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PHONE] || {}
);
export const allYardiVoyagerOtherOccupantsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT] || {}
);
export const allYardiVoyagerPmcCustomColumnSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS] || {}
);
export const allYardiVoyagerPmcStatsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS] || {}
);
export const allYardiVoyagerPmcStatsCollectorsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR] || {}
);
export const allYardiVoyagerActiveScanLogEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY] || {}
);
export const allYardiVoyagerSystemSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS] || {}
);

export const UserAccountSelector = createSelector(
	[allUserAccountsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserAccountBalanceSelector = createSelector(
	[allUserAccountBalancesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserAccountBalanceSourceSelector = createSelector(
	[allUserAccountBalanceSourcesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserHistoryEntrySelector = createSelector(
	[allUserHistoryEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BalanceChangeLogSelector = createSelector(
	[allBalanceChangeLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const InternationalUserBankAccountSelector = createSelector(
	[allInternationalBankAccountsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const USDomesticUserBankAccountSelector = createSelector(
	[allUSDomesticBankAccountsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserBankAccountDeltaSelector = createSelector(
	[allUserBankAccountDeltasSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserAccountSettingsSelector = createSelector(
	[allUserAccountSettingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const AdminGhostUserAccountSelector = createSelector(
	[allAdminGhostUserAccountsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserAccountFinalizationSelector = createSelector(
	[allUserAccountFinalizationsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ThirdPartyUserAccountMappingSelector = createSelector(
	[allThirdPartyUserAccountMappingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PreviousEmailAddressSelector = createSelector(
	[allPreviousEmailAddressesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PendingEmailChangeSelector = createSelector(
	[allPendingEmailChangesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ArchivedPendingEmailChangeSelector = createSelector(
	[allArchivedPendingEmailChangesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PasswordSelector = createSelector(
	[allPasswordsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ExpiredPasswordSelector = createSelector(
	[allExpiredPasswordsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PasswordResetSelector = createSelector(
	[allPasswordResetsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositSelector = createSelector(
	[allDepositsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositInviteSelector = createSelector(
	[allDepositInvitesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositAdjustmentSelector = createSelector(
	[allDepositAdjustmentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositInterestSelector = createSelector(
	[allDepositInterestsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositHistoryEntrySelector = createSelector(
	[allDepositHistoryEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositCloseRequestSelector = createSelector(
	[allDepositCloseRequestsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositUserStatsSelector = createSelector(
	[allDepositUserStatsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositBankMappingSelector = createSelector(
	[allDepositBankMappingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositBulkImportSelector = createSelector(
	[allDepositBulkImportsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositInterestLogSelector = createSelector(
	[allDepositInterestLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ArchivedDepositCloseRequestSelector = createSelector(
	[allArchivedDepositCloseRequestsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositWithheldFundsSelector = createSelector(
	[allDepositWithheldFundsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PMCReportTimetableSelector = createSelector(
	[allPmcReportTimetablesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositGroupSelector = createSelector(
	[allDepositGroupsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositPostCloseAdjustmentSelector = createSelector(
	[allDepositPostCloseAdjustmentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DepositUserGroupSelector = createSelector(
	[allDepositUserGroupsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PropertyGroupSelector = createSelector(
	[allPropertyGroupsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PropertyUserGroupSelector = createSelector(
	[allPropertyUserGroupsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DisputeSelector = createSelector(
	[allDisputesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DisputeSplitSelector = createSelector(
	[allDisputeSplitsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DisputeInterventionRequestSelector = createSelector(
	[allDisputeInterventionRequestsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PropertySelector = createSelector(
	[allPropertiesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PropertyAddressSelector = createSelector(
	[allPropertyAddressesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ComplianceSelector = createSelector(
	[allCompliancesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ComplianceRuleSelector = createSelector(
	[allComplianceRuleSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ComplianceHistorySelector = createSelector(
	[allComplianceHistoriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const EmailTemplateSelector = createSelector(
	[allEmailTemplatesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const EmailVerificationSelector = createSelector(
	[allEmailVerificationsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const EmailVerificationRecordSelector = createSelector(
	[allEmailVerificationRecordsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const EmailEventSelector = createSelector(
	[allEmailEventsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const SentEmailSelector = createSelector(
	[allSentEmailsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const MailboxSelector = createSelector(
	[allMailboxesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const MailboxMetaDataSelector = createSelector(
	[allMailboxMetaDataSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const MailboxMessageSelector = createSelector(
	[allMailboxMessagesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PermissionEntrySelector = createSelector(
	[allPermissionEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PermissionLogEntrySelector = createSelector(
	[allPermissionLogEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PermissionsOrganizationSettingsSelector = createSelector(
	[allPermissionsOrganizationSettingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ResourcePermissionSelector = createSelector(
	[allResourcePermissionsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const OrganizationSelector = createSelector(
	[allOrganizationsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const OrganizationResourcePermissionRuleSelector = createSelector(
	[allOrganizationResourcePermissionRulesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const InvoiceSelector = createSelector(
	[allInvoicesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const InvoiceItemSelector = createSelector(
	[allInvoiceItemsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PaymentRequestSelector = createSelector(
	[allPaymentRequestsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const StripePaymentLogSelector = createSelector(
	[allStripePaymentLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserWithdrawSelector = createSelector(
	[allUserWithdrawsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PriorityACHPaymentSelector = createSelector(
	[allPriorityAchPaymentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PriorityACHRecurringPaymentSelector = createSelector(
	[allPriorityAchRecurringPaymentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const LoanApplicationSelector = createSelector(
	[allLoanApplicationsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const LoanSystemInfoSelector = createSelector(
	[allLoanSystemInfosSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const LoanSelector = createSelector(
	[allLoansSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const LoanHistorySelector = createSelector(
	[allHistoryEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const LoanPaymentLogSelector = createSelector(
	[allLoanPaymentLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const StripeWebhookLogSelector = createSelector(
	[allLogEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserAccountPaymentProviderInfoSelector = createSelector(
	[allInfoSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const SezzleOrderSelector = createSelector(
	[allSezzleOrdersSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const SezzleWebhookEventSelector = createSelector(
	[allSezzleWebhookEventsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BankAccountSelector = createSelector(
	[allBankAccountsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BankAccountHistoricalInterestRateSelector = createSelector(
	[allBankAccountHistoricalInterestRatesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BankAccountInterestSelector = createSelector(
	[allBankAccountInterestsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BankAccountBalanceRecordSelector = createSelector(
	[allBankAccountBalanceRecordsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BankTransferSelector = createSelector(
	[allBankTransfersSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BulkFundsTransferSelector = createSelector(
	[allBulkFundsTransfersSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const FundsLockSelector = createSelector(
	[allFundsLocksSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const FundsLockReleaseLogSelector = createSelector(
	[allFundsLockReleaseLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ReleasedFundsLockSelector = createSelector(
	[allReleasedFundsLocksSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const BalanceSourceTransferSelector = createSelector(
	[allBalanceSourceTransfersSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const CreditUserAccountLogSelector = createSelector(
	[allCreditUserAccountLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const EventSelector = createSelector(
	[allEventsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const EventHookSelector = createSelector(
	[allEventHooksSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const NotificationSelector = createSelector(
	[allNotificationsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ActionItemSelector = createSelector(
	[allActionItemsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UpdateLogSelector = createSelector(
	[allUpdateLogsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const StorageFileSelector = createSelector(
	[allStorageFilesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const AttachedStorageFilesSelector = createSelector(
	[allAttachedStorageFilesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const SystemHistoryEntrySelector = createSelector(
	[allSystemHistoryEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const SnapshotSelector = createSelector(
	[allSnapshotsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const IPAddressSelector = createSelector(
	[allIpAddressesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const KnownIPAddressSelector = createSelector(
	[allKnownIpAddressesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const UserAgentSelector = createSelector(
	[allUserAgentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const KnownUserAgentSelector = createSelector(
	[allKnownUserAgentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const SystemStatsSelector = createSelector(
	[allSystemStatsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const ResourceNoteSelector = createSelector(
	[allResourceNoteSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const DeposifyTagSelector = createSelector(
	[allDeposifyTagsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const PermanentLinkSelector = createSelector(
	[allLinksSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const OnlineUserSelector = createSelector(
	[allOnlineUsersSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const FrontendGeneralSettingsSelector = createSelector(
	[allFrontendGeneralSettingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiScreeningWorksProXMLSelector = createSelector(
	[allYardiScreeningWorksProXmlSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerXMLSelector = createSelector(
	[allYardiVoyagerXmlSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerTransactionSelector = createSelector(
	[allYardiVoyagerTransactionsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerResidentSelector = createSelector(
	[allYardiVoyagerResidentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerResidentCustomColumnSelector = createSelector(
	[allYardiVoyagerResidentCustomColumnsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPropertyUnitSelector = createSelector(
	[allYardiVoyagerPropertyUnitsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPropertySelector = createSelector(
	[allYardiVoyagerPropertiesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPMCServiceInterfaceVersionSelector = createSelector(
	[allYardiVoyagerPmcServiceInterfaceVersionsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPMCSelector = createSelector(
	[allYardiVoyagerPmcsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPMCCredentialsSelector = createSelector(
	[allYardiVoyagerPmcCredentialsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPetSelector = createSelector(
	[allYardiVoyagerPetsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerILSGuestCardEventSelector = createSelector(
	[allYardiVoyagerIlsGuestCardEventsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerChargeSelector = createSelector(
	[allYardiVoyagerChargesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerChargeCodeSelector = createSelector(
	[allYardiVoyagerChargeCodesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerDepositCreateIntentSelector = createSelector(
	[allYardiVoyagerDepositCreateIntentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerDepositCloseIntentSelector = createSelector(
	[allYardiVoyagerDepositCloseIntentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerDepositWithholdIntentSelector = createSelector(
	[allYardiVoyagerDepositWithholdIntentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerEventSelector = createSelector(
	[allYardiVoyagerEventsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerFlexDepositIntentSelector = createSelector(
	[allYardiVoyagerFlexDepositIntentsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPhoneSelector = createSelector(
	[allYardiVoyagerPhonesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerOtherOccupantSelector = createSelector(
	[allYardiVoyagerOtherOccupantsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPMCCustomColumnSettingsSelector = createSelector(
	[allYardiVoyagerPmcCustomColumnSettingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPMCStatsSelector = createSelector(
	[allYardiVoyagerPmcStatsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerPMCStatsCollectorSelector = createSelector(
	[allYardiVoyagerPmcStatsCollectorsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerActiveScanLogEntrySelector = createSelector(
	[allYardiVoyagerActiveScanLogEntriesSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
export const YardiVoyagerSystemSettingsSelector = createSelector(
	[allYardiVoyagerSystemSettingsSelector, uuidSelector],
	(incomingDict, resourceUID) => incomingDict[resourceUID]
);
